<template>
	<LeftSidebar :dark=false :width="600" :open="searchResultSidebarOpen" :updateSidebar="updateSearchResultSidebar"
		>

		<div slot="sbTitle">
			{{this.searchTitle}}
    	</div> 

    	<v-flex slot="sbContent" class="caption">
    		<v-tooltip bottom >
	    		<v-btn slot="activator" icon dark @click="exportTable" style="position: fixed; right: 10px; top: 75px;">
						<v-icon>save_alt</v-icon>
				</v-btn>
				Export Data
			</v-tooltip>

			<v-tooltip bottom v-if="(isVisibleRemoveOccupantPIButton ) && searchTitle == 'Principal Investigator Search'">
				<v-btn slot="activator" icon dark @click="occupantPIRemoveDialog=true" style="position: fixed; right: 50px; top: 75px;">
						<v-icon :class="{glowIcon: roomKeys.length > 0}">delete</v-icon>
				</v-btn>
				Delete PI {{searchResults.name}} from {{roomKeys.length > 0 ? 'selected' : 'ALL'}} rooms.
			</v-tooltip>
			<v-tooltip bottom v-if="(isVisibleRemoveOccupantPIButton ) && searchTitle == 'Occupant Search'">
				<v-btn slot="activator" icon dark @click="occupantPIRemoveDialog=true" style="position: fixed; right: 50px; top: 75px;">
						<v-icon :color="roomKeys.length > 0 ? 'red' : ''" :class="{glowIcon: roomKeys.length > 0}">delete</v-icon>
				</v-btn>
				Delete Occupant {{searchResults.name}} from {{roomKeys.length > 0 ? 'selected' : 'ALL'}} rooms.
			</v-tooltip>
			
			<div class="stsub subheading" v-html="searchSubtitle">
			</div>
			
			<!-- <v-subheader class="pl-4">Buildings</v-subheader> -->
			
			<v-expansion-panel v-if="searchResults" v-model="expanded" expand >
				<v-card v-if="searchResults.roomCount > 4000" 
					class="py-1 text-xs-center body-1"
					radius="0"
					style="width: 100%; " 
					color="light-green accent-2">Very large data set. Interface may lag. Be patient with clicks.</v-card>
 				<v-expansion-panel-content  v-for="(site,siteIndex) in searchResults.sites" :key="siteIndex" 
 				:style="darkTheme ? 'background-color: #111111;' : 'background-color: #DDDDDD;'" >
					<v-layout slot="header" @click="siteClick(site.siteID)" justify-space-between align-center>
						<v-flex style="font-weight: 500;">{{site.deptName ? site.deptName : site.siteName}}</v-flex>
						<v-flex shrink class="mr-2">{{siteAreaSum(site).toLocaleString()}} sf</v-flex>
						<v-flex shrink class="mr-2" v-if="siteIndex==0"> <!-- Only show on first one -->				
							<v-tooltip top>
								<v-icon slot="activator" @click.stop="expandSections" style="font-size: 16pt;">
									unfold_more
								</v-icon>
								{{expandAll ? 'Collapse All' : 'Expand All'}}
							</v-tooltip>
						</v-flex>						
					</v-layout>
 					<v-expansion-panel v-if="site.buildings && expanded[siteIndex]" v-model="expandedBldgs[siteIndex]" expand>
						<v-flex >
							<v-flex class="pl-4 pb-1">Highlight Rooms by Floor</v-flex>
							
							
							<v-flex class="pl-3 pb-2">
								<v-btn @click="elevator(floor, site.siteID)" 
								style="min-width: 0px;"
								v-for="(floor, i) in validFloors(site)" 
								:key="i"
								:color="isCurrentFloor(floor) ? 'info' : '' "
								:depressed="isCurrentFloor(floor)"
								width="20">
								{{floor}}
							</v-btn></v-flex>

							
						</v-flex> 
						<v-expansion-panel-content   v-for="(bldg, bldgIndex) in site.buildings" :key="bldgIndex"  
						:style="darkTheme ? 'background-color: #111111;' : 'background-color: #EEEEEE'">
							<v-layout style="font-weight: 500;" slot="header">
								<v-flex xs1 class="text-xs-right">
									{{bldg.bldgAlpha}}
								</v-flex>
								<v-flex class="px-3">
									{{bldg.name}}
								</v-flex>
								<v-spacer></v-spacer>
								<v-flex shrink class="text-xs-right mr-3">
									<v-tooltip top>
										<span slot="activator">{{bldgAreaSum(bldg).toLocaleString()}} sf</span>
										<span>Building Total</span>
									</v-tooltip>
								</v-flex>
							</v-layout>
							<v-card>
								<v-expansion-panel v-if="bldg.floors" v-model="expandedFloors[siteIndex][bldgIndex]" expand>
									<v-expansion-panel-content v-for="(floor, i) in bldg.floors" :key="i" 
									:style="darkTheme ? 'background-color: #111111;' : 'background-color: #FDFDFD'">
										<v-layout justify-space-between
											class="caption" style="font-weight: 500;" slot="header">
											<div style="margin-left: 60px;" class="crosshair" @click.stop="floorClickHandler(floor.number, bldg.bldgAlpha, site)">Floor {{floor.number}}												
											</div>
											<v-flex shrink class="mr-3 caption">{{floorAreaSum(floor).toLocaleString()}} sf</v-flex>
										</v-layout>
										<v-list class="searchlist"v-if="bldg.floors.length > 0" two-line>
										  	<template >
											  	<v-divider></v-divider>
												<v-container class="pl-4 pt-3">									
													<v-list-tile  v-for="(room,i) in floor.rooms" :key="i" avatar @click="roomClickHandler(room)">
														<v-list-tile-content class="crosshair">
															<v-list-tile-title 
																class="caption"
																@mouseover="hoverHandler(room)"
																@mouseout="outHandler()">
																	<v-layout >
																		<v-flex xs1></v-flex>
																		<v-flex xs1 class="fixInputSelectionControls" v-if="isVisibleRemoveOccupantPIButton">
																			<v-checkbox	
																				v-model="room.selected"	
																				@click.stop="vueSet(room, room.selected)"
																				color="primary">
																			</v-checkbox>
																		</v-flex>
																		<v-flex xs3 class="text-xs-left">
																			{{room.number}}
																		</v-flex xs3>
																		<v-flex class="text-xs-left"> 
																			{{(room.classification != "None") ? room.classification : room.categoryName}}
																		</v-flex>
																		<v-flex class="text-xs-right">
																			{{room.area && room.area.toLocaleString()}} sf
																		</v-flex>
																	</v-layout>
															</v-list-tile-title>
														</v-list-tile-content>
													</v-list-tile>
												</v-container>
										  	</template>
										</v-list>
									</v-expansion-panel-content>  
									
								</v-expansion-panel>

							</v-card>
							
						</v-expansion-panel-content>

			</v-expansion-panel>
			</v-expansion-panel-content>


			</v-expansion-panel>
			<PieCharts />
			<v-dialog width="500" v-model="occupantPIRemoveDialog">
	        	<v-card v-if="searchResults" class="pl-2 pt-1 pr-2">
			        <v-card-title v-if="searchTitle == 'Principal Investigator Search'" class="headline">Confirm BULK PI REMOVAL</v-card-title>
			        <v-card-title v-if="searchTitle == 'Occupant Search'" class="headline">Confirm BULK OCCUPANT REMOVAL</v-card-title>
			        <v-divider></v-divider>
			        <v-card-text class="pt-4 body-2" v-if="roomKeys.length > 0">
			        	Remove {{searchResults.name}} from {{roomKeys.length}} room{{roomKeys.length > 1 ? 's' : ''}}?
					</v-card-text>
			        <v-card-text class="pt-4 body-2" v-else>
			        	Remove {{searchResults.name}} from ALL SPACES ({{searchResults.roomCount}} room{{searchResults.roomCount > 1 ? 's' : ''}}) ?
					</v-card-text>
			        <v-card-actions>
			          	<v-spacer></v-spacer>
			          	<v-btn color="green darken-1" flat @click.native="occupantPIRemoveDialog=false">No</v-btn>
			          	<v-btn color="green darken-1" flat 
			          		@click.native="bulkDelPeople">Yes
			      	 	</v-btn>
			        </v-card-actions>
		      	</v-card>
	    	</v-dialog>
		</v-flex>

		
		
	</LeftSidebar>
</template>

<script>
import { mapMutations, mapGetters, mapState, mapActions } from 'vuex'
import LeftSidebar from '@/components/LeftSidebar'
import PieCharts from '@/components/search/PieCharts'
import XLSX from 'xlsx'
import Vue from 'vue'
export default {
	
	data: function () {
		return {
			//expanded: {},
			expanded: [],					// Array
			expandedBldgs: [[]],			// Array of Arrays
			expandedFloors: [], // Array of Arrays of Arrays, could not expand more than 1st site without this
			occupantPIRemoveDialog: false,
			roomKeys: [],
			expandAll: false,
	
		}			
	},

	components: { LeftSidebar, PieCharts},

	computed: 	{
		...mapState({
						isSuperUser:   					state => state.user.isSuperUser,
						stateSearchResultSidebarOpen: 	state => state.ui.searchResultSidebarOpen,
						searchResults: 					state => state.search.searchResults,
						searchTitle: 					state => state.search.searchTitle,
						searchSubtitle: 				state => state.search.searchSubtitle,
						searchExportText: 				state => state.search.searchExportText,
						searchHeaders: 					state => state.search.searchHeaders,
						searchSort: 					state => state.search.searchSort,
						buildingRooms: 					state => state.space.buildingRooms,
						selectedBuilding: 				state => state.space.selectedBuilding,
						highlightRoomsByKey: 			state => state.mapFunctions.highlightRoomsByKey,
						currentFloor: 					state => state.ui.currentFloor,
						clearGraphics: 					state => state.mapFunctions.clearGraphics,
						darkTheme:       				state => state.ui.darkTheme,

			}),
		
		...mapGetters(['allowOccupantEditorUI', 'allowManagerUI']),
		
		searchResultSidebarOpen: {
			get () {
			  return this.stateSearchResultSidebarOpen
			},
			set (value) {
			}
		},

		isVisibleRemoveOccupantPIButton: function () {
			if ((this.isSuperUser || this.allowOccupantEditorUI || this.allowManagerUI) && 
			    (this.searchTitle == 'Principal Investigator Search' || this.searchTitle == 'Occupant Search'))
			   { return true }
		},

	},

		watch: {
		searchResults (val) {
			this.setMainMenuIsTemporary(false)
			this.clearGraphics()
			console.log("search results", val)

			if (!val) {
				console.log("No search results.  Returning.")
				return
			}

			this.expanded=[]
			this.expandedBldgs=[[]]

			// initialize array that holds expansion states
			this.expandedFloors = []
			val.sites.forEach((site) => {
				this.expandedFloors.push([[]])
			})

			// Skip if this was a college search.  Instead list departments closed.
			if (!val.departments) {

				// If top of result set is small enough, expand it
				if (val.sites[0].buildings[0].floors[0].rooms.length < 2 ) { 
					this.expandedBldgs[0] = 0
					this.expandedFloors[0] = []
					this.expandedFloors[0][0] = 0

					// If only one building, open it.  			
					if (val.sites.length == 1 ) {
						this.expanded[0] = true
					} else {
						this.expanded = []
					}
				} else {
					// Larger dataset.  Open 1st section, leave buildings/floors collapsed
					this.expanded=[true]
				}
			}



			//highlight first floor
			this.setCurrentFloor(val.sites[0].buildings[0].floors[0].number)
			this.highlightAll(val.sites[0].siteID)


			
			//this.selectBuilding(null)
			this.selectBuilding(null)		// Asynchronous Action
			this.setSelectedRoom(null)
			this.setBuildingCardOpen(true)
		}
	},
	
	methods: {
		...mapMutations([	'updateSearchResultSidebar',
							'updateSelectionCentering',
							'setSelectedRoom',
							'setCurrentFloor',
							'setHoverRoomNumber',
							'setSelectedRoom',
							'setBuildingCardOpen',
							'setBuildingRooms',
							'setLegendOpen',
							'setSelectedBuilding',
							'setMainMenuIsTemporary',
							'setSnackText',
							'clearSearch',
			]),

		...mapActions([		'selectBuilding', 'addCrossCampusRoomInteractivity', 'fetchFullRoom', 
							'deleteOccupantFromAll', 'deletePIFromAll', 'bulkDeleteOccupants', 'bulkDeletePIs', 'deletePIFromSelected', 'deleteOccupantFromSelected'
			]),

		floorAreaSum (floor) {
			let areaSum = 0;
			floor.rooms.forEach((room) => {
				areaSum += room.area
			})
			return areaSum
		},

		bldgAreaSum (bldg) {
			let areaSum = 0;
			bldg.floors.forEach((floor) => {
				floor.rooms.forEach((room) => {
					areaSum += room.area
				})
			})
			return areaSum
		},

		siteAreaSum (site) {
			let areaSum = 0;
			site.buildings.forEach((bldg) => {
				bldg.floors.forEach((floor) =>{
					floor.rooms.forEach((room) => {
						areaSum += room.area
					})
				})
			})
			return areaSum
		},

		siteClick: function(siteID) {
			this.highlightAll(siteID)
		},

		expandSections () {
			if (!this.expandAll) {
				// Sites
				this.searchResults.sites.forEach((site, siteIndex) => {
					this.expanded[siteIndex] = true
					this.expandedBldgs[siteIndex] = []			// Initialize prior to setting
					this.expandedFloors[siteIndex] = [[]]			// Initialize prior to setting
					Vue.set(this.expanded, siteIndex, true)
					
					// Buildings
					site.buildings.forEach((bldg, buildingIndex) => { 
						Vue.set(this.expandedBldgs[siteIndex], buildingIndex, true)
						this.expandedFloors[siteIndex][buildingIndex] = [] // Initialize prior to setting
						
						// Floors
						bldg.floors.forEach((floor, floorIndex) => { 
							Vue.set(this.expandedFloors[siteIndex][buildingIndex], floorIndex, true)
						})
					})
				})
				this.expandAll = true  			// Set Toggle Indicator
			} else {
				// Clear all arrays for expansion panels
				this.expanded=[]
				this.expandedBldgs=[[]]
				this.expandedFloors=[[[]],[[]],[[]],[[]],[[]],[[]]] // Array of Arrays of Arrays, could not expand more than 1st site without this
				this.expandAll = false			// Set Toggle Indicator
			}
		},		

		validFloors: function(site) {

			let floors = []

			site.buildings.forEach((bldg) => { 
				bldg.floors.forEach((floor) => { 
					if (floors.indexOf(floor.number) == -1) {
						floors.push(floor.number)
					}				
				})
			})
			
			floors.sort(compareFunction)
					function compareFunction (a,b) {
						if (a=="B" || a=="B1") {
							return -1
						} else if (b=="B" || b=="B1") {
							return 1
						} else { return a-b }
					}

			//this.setCurrentFloor(floors[0])
			return floors
		},

/*		panelExpand: function (item) {
			this.expanded[`${item.bldgAlpha}`] = true
		},*/

		isCurrentFloor : function (floor) {
			return (floor == this.currentFloor) ? true : false
		},

	    roomClickHandler: function (room) {
	        this.updateSelectionCentering(true)
	        this.selectBuilding(room.bldgAlpha).then(() => this.fetchFullRoom( {bldgAlpha: room.bldgAlpha, number: room.number} ) )
	        
		},

		elevator: function (floor, siteID) {
				//console.log("SiteID: ", siteID)
				this.setSelectedBuilding(null)
				this.setCurrentFloor(floor)
				this.highlightAll(siteID)
		},

		floorClickHandler: function (floornumber, bldg, site) {	
		 	this.selectBuilding(bldg).then(() => {
				let building = site.buildings.find((item) => item.bldgAlpha == bldg)
				let floor = building.floors.find((item) => item.number == floornumber)
				let rooms = floor.rooms.filter((room) => room.floor == floornumber);
                this.setCurrentFloor(floornumber)
                this.updateSelectionCentering(true)
                if (this.searchResults.deptID) {
                	this.setLegendOpen(true)
					// Second argument is the room property to legend by
					this.highlightRoomsByKey(rooms.map((room) => {return room.roomKey}), 'category', 'center')

					// AddCrossCampusRI is superfluous at this point since building hover will load RI Layer.
					this.addCrossCampusRoomInteractivity(this.searchResults.deptID)
				} else {
                	this.highlightRoomsByKey(rooms.map((room) => {return room.roomKey}))   
                }             
			})
		},

/*		bldgClickHandler: function (bldgAlpha) {
			this.updateSelectionCentering(true)
	        this.selectBuilding(bldgAlpha)
		},*/

		highlightAll: function (siteID) {
			if (this.searchResults.deptID) {
				this.highlightRoomsByKey(this.searchResults.deptID, 'category', 'center', siteID )
				// AddCrossCampusRI is superfluous at this point since building hover will load RI Layer.
				this.addCrossCampusRoomInteractivity(this.searchResults.deptID)
				this.setLegendOpen(true)
				this.setBuildingCardOpen(false)
			} else {				
				const roomsArray = []
				const site = this.searchResults.sites.find(site => {return site.siteID == siteID});
				site.buildings.map((bldg) => { 
						bldg.floors.map((floor) => { 
							floor.rooms.filter((room) => room.floor === this.currentFloor)
							.map((room) => { roomsArray.push(room.roomKey) })				
					})
				})
				this.highlightRoomsByKey(roomsArray, false, 'center')				// 'rgba(255, 0, 0, .3)'
			}				
		},

/*		replaceBuildingRooms: function () {
			let rooms = []
			this.searchResults.buildings.map((bldg) => {
				bldg.floors.filter((floor) => floor.number == this.currentFloor).map((floor) => {
					console.log(floor.rooms)
					rooms.concat(floor.rooms)
				})
			})
			console.log(rooms)
		},*/



		hoverHandler: function (room) {
			this.setHoverRoomNumber(room.roomKey)
		},
		
		outHandler: function () {
			this.setHoverRoomNumber(null)
		},

		bulkDelPeople: async function() { 			

			let response = ""
			let peopleType = ""
			
			// Call correct action PI or Occupant Deletion.  
			// Use bulk if there are selected roomKeys, or do complete employee level deletion
			if (this.searchTitle == 'Principal Investigator Search' ) {
				peopleType = "PI"
				if (this.roomKeys.length > 0) 	{ 
							response = await this.deletePIFromSelected({employeeID: this.searchResults.employeeID, room_key_array: this.roomKeys})
			    } else { 	response = await this.deletePIFromAll( {employeeID: this.searchResults.employeeID}) 
				}
			}
			
			if (this.searchTitle == 'Occupant Search' ) {
				peopleType = "Occupant"
				if (this.roomKeys.length > 0) 	{ 
							response = await this.deleteOccupantFromSelected({employeeID: this.searchResults.employeeID, room_key_array: this.roomKeys})
				} else { 	response = await this.deleteOccupantFromAll( {employeeID: this.searchResults.employeeID})  }
			
			}

			// Report to UI, close search
			if (response.includes("removed from")) {
				this.setSnackText(response)			
				this.updateSearchResultSidebar(false)
				this.roomKeys=[]
			} else {
				this.occupantPIRemoveDialog = false
				this.setSnackText(`Error: ${response}`)	
			}
		}, 

/*		deletePIFromAllRooms: async function () {
			let response = await this.deletePIFromAll({employeeID: this.searchResults.employeeID})
			if (response == 'Deleted') {
				this.occupantPIRemoveDialog = false
				this.setSnackText(`PI ${this.searchResults.name} was deleted from ${this.searchResults.roomCount} room${this.searchResults.roomCount > 1 ? 's' : ''}`)				
				this.updateSearchResultSidebar(false)
			} else {
				this.occupantPIRemoveDialog = false
				this.setSnackText(`Error: ${response}`)				
			}

		},

		deleteOccupantFromAllRooms: async function () {	
			let response = await this.deleteOccupantFromAll({employeeID: this.searchResults.employeeID})
			if (response == 'Deleted') {
				this.occupantPIRemoveDialog = false
				this.setSnackText(`Occupant ${this.searchResults.name} was deleted from ${this.searchResults.roomCount} room${this.searchResults.roomCount > 1 ? 's' : ''}`)
				this.updateSearchResultSidebar(false)	
			} else {
				this.occupantPIRemoveDialog = false	
				this.setSnackText(`Error: ${response}`)										
			}

		},*/

		vueSet: function (room, selected) {
			Vue.set(room, 'selected', !selected)

			// Update roomKeys
			this.roomKeys = []
			this.searchResults.sites.forEach((site) => {
				site.buildings.forEach((building) => {
					building.floors.forEach((floor) => {
						floor.rooms.forEach((room) => {						
							if (room.selected) { this.roomKeys.push(room.bldgAlpha + "+" + room.number) }
						})
					})
				})
			})
			console.log(this.roomKeys)
		},

		exportTable: function () {
	      	// Create workbook
	      	const wb = XLSX.utils.book_new() 

	      	// Format some text, remove <br>
/*	      	const regexBr 	= new RegExp('<br>', 'gi');
			let nicerText 	= this.searchExportText.replace(regexBr, ' & ');
			nicerText 		= nicerText.slice(0, -3) // take last two chars off*/
	      	console.log(this.searchExportText)

	      	// Create worksheet, and add info
	      	let ws = XLSX.utils.aoa_to_sheet([
						[`UArizona Interactive Floorplans - ${this.searchTitle}`],
						[`${this.searchExportText}`],
						[""],
						["Area Sum",this.searchResults.areaSum.toLocaleString()],
						["Building Count",this.searchResults.bldgCount],
						["Room Count",this.searchResults.roomCount],
						this.searchResults.borrowedAreaSum && this.searchResults.borrowedAreaSum != 0 ? ["Borrowed Area Sum",this.searchResults.borrowedAreaSum.toLocaleString()] : null,
					])

	      	let rooms = []

	      	// crawl through object and push rooms into temp array
	      	this.searchResults.sites.forEach((site) => {
	      		site.buildings.forEach((bldg) => {
	      			bldg.floors.forEach((floor) => {
	      				floor.rooms.forEach((room) => {
	      					rooms.push(room)
	      				})
	      			})
	      		})
	      	})

	      	let roomData = rooms.map((room) => {
				return 	{	Building: 			room.bldgAlpha,
	  						Name: 				room.bldgName,
	  						Floor: 				room.floor,
	  						Room: 				room.number,
	  						College: 			`${room.collegeName} (${room.collegeID})`,
	  						Dept: 				`${room.deptName} (${room.deptID})`,
	  						Classification: 	room.classification,
							Programs:			room.programs,
	  						Category: 			room.category,
	  						CatName: 			room.categoryName,
	  						Type: 				room.type,
	  						TypeName: 			room.typeName,
	  						Use: 				room.use,
	  						UseName: 			room.useName,
							Capacity: 			room.capacity,
	  						Area: 				room.area,
							UserDept:			room.userDeptName
							

					}
		  	})
	      	


	      	XLSX.utils.sheet_add_json(ws, roomData, { origin:"A9" })

			// Column Widths
			var wscols = [
				    {wch:10},
				    {wch:10},
				    {wch:10},
				    {wch:10},
				    {wch:30},
				    {wch:30},
				    {wch:20},
				    {wch:30},
					{wch:10},
				    {wch:30},
				    {wch:10},
				    {wch:30},
				    {wch:10},
				    {wch:30},
				    {wch:10},
				    {wch:10},
					{wch:30},
				];

			ws['!cols'] = wscols;

	      
	      	// add Worksheet to Workbook
	        XLSX.utils.book_append_sheet(wb, ws, `${this.searchTitle}`)

	      	// export Excel file
	      	XLSX.writeFile(wb, `IFSearchResults-${this.searchTitle}.xlsx`) 

	    },


	}
} 
</script>

<style>

/*Vuetify OVERRIDE*/
.navigation-drawer {
	padding: 0;
}

.srHeader
{
    height:50px;
}

.srContent
{
    position:absolute;
    top: 64px;
    padding-right: 10px;
    left:0px;
    right:0px;
    bottom:0px;
    overflow-y:scroll; 
    overflow-x:hidden;       
}

.crosshair {
	cursor: crosshair !important;
}
.stsub {
	padding-top: 20px;
	padding-left: 25px;
}

/*.searchpanel {
	top: 64px !important;
	height: 100%;
	box-shadow: -6px 6px 80px -14px #000;
	height: 85vh !important; 
	z-index: 19 !important;
	overflow: hidden !important; 
}*/

/*Simlar style on ContentSidebar.vue*/
.searchpanel .sidebarScrollable {
	overflow-y: scroll;
	overflow-x: hidden;
	height: 100%;
	padding: 0;
}

.searchlist .v-list__tile {
    height: 30px !important;
    padding-top: 1px;
}

.searchList .v-list__tile > .title {
	padding-bottom: -5px;
	line-height: normal !important;
}

.fixInputSelectionControls .v-input--selection-controls {
 	margin-top: 0px;
 	padding-top: 0px;
 }

 @keyframes glowing {
  0% { box-shadow: 0 0 -10px #e6ffff; }
  40% { box-shadow: 0 0 30px #e6ffff; }
  60% { box-shadow: 0 0 30px #e6ffff; }
  100% { box-shadow: 0 0 -10px #e6ffff; }
}

.glowIcon {
    border-radius: 20px;    
    animation: glowing 2000ms infinite;
}


</style>


// WEBPACK FOOTER //
// src/components/search/searchResultSidebarNew.vue